<template>
  <v-app>
    <div class="page-container" v-if="$route.name !== 'pdf'">
      <v-app-bar color="primary" dark app>
        <v-app-bar-nav-icon @click="menuVisible = !menuVisible"></v-app-bar-nav-icon>
        <v-app-bar-title>MJ Backhouse</v-app-bar-title>

        <v-spacer></v-spacer>

        <div v-if="$store.state.user" class="d-flex align-center">
          <span class="me-3">{{ $store.state.user.name || "Darren Backhouse" }}</span>
          <v-btn @click="logOut" icon="mdi-logout" variant="text"></v-btn>
        </div>

        <template v-slot:extension>
          <!-- no wrapper element: it would size to all the tabs and stop the slide group scrolling to the last ones -->
          <v-tabs v-if="!toolbarPages.includes($route.name)" color="white" slider-color="white" stacked height="74" show-arrows>
            <v-tab v-if="isAdmin" :to="{ name: 'search' }" exact>
              <v-icon>mdi-magnify</v-icon>
              <span class="nav-title"> JOB SEARCH </span>
            </v-tab>
            <v-tab :to="isAdmin ? { name: 'schedule' } : { name: 'engineer-schedule' }" exact>
              <v-icon>mdi-calendar</v-icon>
              <span class="nav-title"> SCHEDULE </span>
            </v-tab>
            <v-tab v-if="isAdmin" :to="{ name: 'customers' }" exact>
              <v-icon>mdi-account-group</v-icon>
              <span class="nav-title"> CUSTOMERS </span>
            </v-tab>
            <v-tab v-if="isAdmin" :to="{ name: 'suspended' }" exact>
              <v-icon>mdi-block-helper</v-icon>
              <span class="nav-title"> SUSPENDED </span>
            </v-tab>
            <v-tab 
              v-if="isUserLoggedIn"
              :to="isAdmin ? { name: 'timesheet' } : { name: 'engineer-timesheet'}"
            >
              <div class="notification-nav-icon">
                <v-icon v-if="timesheetAlertClass && !isAdmin" :class="'navItem-notification ' + timesheetAlertClass">mdi-alert</v-icon>
                <v-icon>mdi-calendar-range-outline</v-icon>
              </div>
              <span class="nav-title"> TIMESHEET </span>
            </v-tab>
            <v-tab 
              v-if="isUserLoggedIn"
              :to="isAdmin ? { name: 'holiday-request' } : { name: 'engineer-holiday-request'}"
              @click="reloadIfSame"
            >
              <v-icon>mdi-bag-suitcase-outline</v-icon>
              <span class="nav-title"> HOLIDAYS </span>
            </v-tab>    
            <v-tab v-if="isUserLoggedIn" :to="isAdmin ? { name: 'stock-control' } : { name: 'engineer-stock-control' }">
              <v-icon>mdi-basket-outline</v-icon>
              <span class="nav-title"> {{ isAdmin ? 'STOCK CONTROL' : 'ORDER STOCK' }} </span>
            </v-tab>
            <!-- Vehicle Inspection route -->
            <v-tab
              v-if="isUserLoggedIn"
              :to="isAdmin ? { name: 'vehicle-inspection' } : { name: 'vehicle-inspection-form' }"
            >
              <div class="notification-nav-icon">
                <v-icon v-if="!isVehicleInspected && !isAdmin" :class="'navItem-notification ' + inspectionAlertClass">mdi-alert</v-icon>
                <v-icon>mdi-truck-outline</v-icon>
              </div>
              <span class="nav-title"> VEHICLE INSPECTION </span>
            </v-tab>
            <v-tab v-if="isAdmin && isUserLoggedIn" :to="{ name: 'configurations' }" exact>
              <v-icon>mdi-cog-outline</v-icon>
              <span class="nav-title"> CONFIGURATIONS </span>
            </v-tab>
          </v-tabs>
        </template>
      </v-app-bar>

      <v-navigation-drawer v-model="menuVisible" temporary>
        <v-list v-if="$store.state.user">
          <template v-if="isAdmin">
            <v-list-item
              @click="
                $router.push({ name: 'search' });
                menuVisible = false
              "
              prepend-icon="mdi-view-dashboard"
              :active="$route.name === 'search' || $route.name === 'index'"
              color="primary"
            >
              <v-list-item-title>Dashboard</v-list-item-title>
            </v-list-item>

            <v-list-item
              @click="
                $router.push({ name: 'scheduler' });
                menuVisible = false
              "
              prepend-icon="mdi-calendar-clock"
              :active="$route.name === 'scheduler'"
              color="primary"
            >
              <v-list-item-title>Visit Scheduler</v-list-item-title>
            </v-list-item>

            <v-list-item
              @click="
                $router.push({ name: 'materials' });
                menuVisible = false
              "
              prepend-icon="mdi-package-variant"
              :active="$route.name === 'materials'"
              color="primary"
            >
              <v-list-item-title>Materials</v-list-item-title>
            </v-list-item>

            <v-list-item
              @click="
                $router.push({ name: 'pests' });
                menuVisible = false
              "
              prepend-icon="mdi-bug"
              :active="$route.name === 'pests'"
              color="primary"
            >
              <v-list-item-title>Pests</v-list-item-title>
            </v-list-item>

            <v-list-item
              @click="
                $router.push({ name: 'engineers' });
                menuVisible = false
              "
              prepend-icon="mdi-account-hard-hat"
              :active="$route.name === 'engineers'"
              color="primary"
            >
              <v-list-item-title>Engineers</v-list-item-title>
            </v-list-item>

            <v-list-item
              @click="
                $router.push({ name: 'vehicles' });
                menuVisible = false
              "
              prepend-icon="mdi-truck-check"
              :active="$route.name === 'vehicles'"
              color="primary"
            >
              <v-list-item-title>Vehicles</v-list-item-title>
            </v-list-item>

            <v-list-item
              @click="
                $router.push({ name: 'staff' });
                menuVisible = false
              "
              prepend-icon="mdi-account-tie"
              :active="$route.name === 'staff'"
              color="primary"
            >
              <v-list-item-title>Office Staff</v-list-item-title>
            </v-list-item>

            <v-list-item
              @click="
                $router.push({ name: 'password' });
                menuVisible = false
              "
              prepend-icon="mdi-lock"
              :active="$route.name === 'password'"
              color="primary"
            >
              <v-list-item-title>Password</v-list-item-title>
            </v-list-item>
          </template>

          <v-list-item
            v-if="!isAdmin"
            @click="
              $router.push({ name: 'profile' });
              menuVisible = false
            "
            prepend-icon="mdi-account-circle"
            :active="$route.name === 'profile'"
            color="primary"
          >
            <v-list-item-title>Profile</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>

      <v-main>
        <router-view class="px-3 px-md-6 px-lg-10 pt-15 pb-10" />
        <error-dialog />
      </v-main>
    </div>

    <div v-if="$route.name == 'pdf'">
      <router-view />
    </div>
  </v-app>
</template>

<script>
import { getInspectionAlertClass, checkInspectionSubmitted } from "@/helpers/js/inspection-submitted-check";
import { getTimesheetAlertClass } from "@/helpers/js/timesheet";
import ErrorDialog from "./views/common/ErrorDialog.vue";

export default {
  name: "App",
  components: {ErrorDialog},
  data() {
    return {
      toolbarPages: ["materials", "pests", "engineers", "staff", "password"],
      menuVisible: false,
      inspectionAlertClass: "",
      timesheetAlertClass: "",
    };
  },
  watch: {
    '$store.state.user': {
      immediate: true,
      async handler() {
        checkInspectionSubmitted();
        this.inspectionAlertClass = await getInspectionAlertClass();
        this.timesheetAlertClass = await getTimesheetAlertClass();
      }
    }
  },
  computed: {
    isAdmin() {
      return this.$store.state.user && this.$store.state.user.Partition_Key == "AdminUser";
    },
    isUserLoggedIn() {
      return this.$store.state.user != null;
    },
    isVehicleInspected() {
      return this.$store.state.isVehicleInspected;
    }
  },
  methods: {
    reloadIfSame(e) {
      const routeName = this.isAdmin ? "holiday-request" : "engineer-holiday-request";

      if (this.$route.name === routeName) {
        e.preventDefault(); // stop router navigation
        this.$router.go(0); // reload page
      }
    },
    
    logOut() {
      this.$store.commit("logOut");
      this.$router.push({ name: "login" });
    }
  }
}
</script>
<style>
/* App styling for Element Plus */
:root {
  --el-color-primary: #7a003c;
}

.app-header {
  background: #7a003c;
  color: white;
  padding: 0 20px;
}

.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}

.header-start {
  display: flex;
  align-items: center;
  gap: 15px;
}

.header-end {
  display: flex;
  align-items: center;
  gap: 15px;
}

.app-title {
  font-size: 20px;
  font-weight: 500;
}

.tableholder {
  margin-top: 50px;
}

.margintop {
  margin: 25px 0 0 0 !important;
}

.limited {
  max-width: 1000px;
}

.md-card.small {
  max-width: 500px;
}

h1 .md-icon {
  color: #999 !important;
  top: -0.2rem;
  position: relative;
  margin-right: 0.5rem;
}

.add {
  background: #448aff !important;
  color: white !important;
}

.add i {
  color: white !important;
}

.md-dialog .md-layout-item {
  margin: auto;
  width: calc(100% - 48px);
}

.md-empty-state-label {
  font-size: 1rem !important;
}

.md-table-head.md-sortable:first-of-type .md-table-sortable-icon,
.md-table-head.md-table-cell-selection + .md-sortable .md-table-sortable-icon {
  right: 0;
}

.md-field.small,
.md-layout-item.small {
  max-width: 300px !important;
  margin-left: 25px;
}

.marginleft {
  margin-left: 25px !important;
}

.right {
  float: right;
}

.padded {
  position: relative;
  top: 10px !important;
}

.canvas {
  border: 1px solid black;
}

.previous {
  background: orange !important;
}

.completed {
  background: green !important;
}

.md-field.md-has-textarea:not(.md-autogrow):after,
.md-field.md-has-textarea:not(.md-autogrow):before {
  border-top: 0 !important;
  border-left: 0 !important;
  border-right: 0 !important;
}

.md-field.md-has-textarea:not(.md-autogrow) label {
  left: 0 !important;
  top: 0 !important;
}
.md-field.md-has-textarea:not(.md-autogrow) .md-textarea {
  padding-left: 0 !important;
}

.disclaimer {
  font-size: 0.7rem;
  padding: 0.5rem 0;
}

.notify {
  margin: 1rem 0;
  display: block;
  clear: both;
}

.clear {
  margin-left: 1rem;
  float: right;
}

.success {
  color: green !important;
}

.error {
  color: #cc0000 !important;
}

.md-card-header {
  display: table;
}

.bait-table {
  width: 100%;
  max-width: 80rem;
  border-collapse: collapse;
}

.bait-table td {
  padding: 0.5rem 1rem;
}

.bait-table thead td {
  background: #f5f5f5;
  font-weight: bold;
}

.bait-table tbody td {
  border-bottom: 1px solid #f5f5f5;
}

.bait-table .md-checkbox.md-theme-default.md-checked .md-checkbox-container {
  background: green;
  border-color: green;
}

.bait-table .activity > * {
  max-width: 5rem !important;
  padding: 5px 5px;
  border: 0;
  border-bottom: 2px solid #757575;
  font-size: 0.7rem;
}
.bait-actions {
  text-align: right;
  width: 100%;
  max-width: 80rem;
  padding-bottom: 0.5rem;
}
.bait-actions button {
  background: #f5f5f5;
}

.bait-legend {
  font-size: 0.8rem;
  padding: 1rem;
  background: #f5f5f5;
  float: left;
  margin-bottom: 1rem;
}

.bait-legend span {
  opacity: 0.5;
}

.highlight textarea {
  color: #cc0000 !important;
  -webkit-text-fill-color: #cc0000 !important;
}

.toolbar {
  display: table;
  width: 100%;
}

.toolbar a {
  display: block;
  padding: 0.5rem 1rem;
  text-align: center;
  float: left;
  color: white !important;
  transition: all 0.3s;
  border-bottom: 3px solid transparent;
  text-transform: uppercase;
}

.toolbar a.sel {
  border-bottom: 3px solid white;
}

.toolbar a:hover {
  background: rgba(255, 255, 255, 0.1);
  text-decoration: none !important;
}

.toolbar a i {
  opacity: 0.5;
}

.field_label {
  color: rgba(0, 0, 0, 0.54);
  font-size: 12px;
  display: block;
  margin-top: 3px;
}

.toolbar a span {
  display: block;
  margin-top: 0.5rem;
  font-size: 13px;
  font-weight: 500;
}

.form-control {
  width: 100%;
  border: 0;
  border-bottom: 1px solid #949494;
  padding: 4px 0 5px 30px;
  font-size: 16px;
  cursor: pointer;
}

.form-control.active,
.form-control:focus {
  border: 0 !important;
  outline: none !important;
  border-bottom: 2px solid #7a003c !important;
}

.flatpickr-day.selected,
.flatpickr-day.startRange,
.flatpickr-day.endRange,
.flatpickr-day.selected.inRange,
.flatpickr-day.startRange.inRange,
.flatpickr-day.endRange.inRange,
.flatpickr-day.selected:focus,
.flatpickr-day.startRange:focus,
.flatpickr-day.endRange:focus,
.flatpickr-day.selected:hover,
.flatpickr-day.startRange:hover,
.flatpickr-day.endRange:hover,
.flatpickr-day.selected.prevMonthDay,
.flatpickr-day.startRange.prevMonthDay,
.flatpickr-day.endRange.prevMonthDay,
.flatpickr-day.selected.nextMonthDay,
.flatpickr-day.startRange.nextMonthDay,
.flatpickr-day.endRange.nextMonthDay {
  background: #7a003c !important;
  border-color: #7a003c !important;
}

.flatpickr-months * {
  color: #7a003c !important;
}

.v-toolbar__extension {
  min-height: 74px !important;
}

.nav-title {
  font-size: 13px;
  font-weight: 500;
  padding: 8px 0 !important;
}

.v-navigation-drawer .v-list {
  margin-top: 20px;
}

.notification-nav-icon {
  position: relative;
}

.navItem-notification {
  position: absolute !important;
  right: -10px;
  top: -8px;
  font-size: 16px !important;
  background-color: #ffffff;
  padding: 12px;
  border-radius: 50%;
  z-index: 99;
}

.warning-allert {
  color: #ffbf00 !important;
}

.error-allert {
  color: #ff0000 !important;
}

@media screen and (max-width: 700px) {
  .md-title > * {
    clear: both;
  }

  .bait-table td {
    padding: 0.5rem 0.25rem;
    font-size: 0.6rem;
  }
}
</style>
